// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2Eqxo","footerText":"Footer_footerText__2j_to"};